/** Suggested organization codes from type and city (ADM-62); editable before submit. */
const TYPE_SEGMENT: Readonly<Record<string, string>> = {
  CLUB: 'CLUB',
  CORPORATE: 'CORP',
  EDUCATION: 'EDU',
  OTHER: 'ORG',
};

const CITY_SEGMENT: Readonly<Record<string, string>> = {
  تهران: 'THR',
  گرگان: 'GOR',
  مشهد: 'MHD',
  اصفهان: 'ISF',
  شیراز: 'SHZ',
  تبریز: 'TBZ',
};

export function suggestOrganizationCode(organizationType: string, cityNameFa: string): string {
  const typeSeg = TYPE_SEGMENT[organizationType] ?? 'ORG';
  const trimmed = cityNameFa.trim();
  const citySeg =
    CITY_SEGMENT[trimmed] ??
    trimmed
      .replace(/\s+/g, '')
      .replace(/[^\u0600-\u06FFa-zA-Z0-9]/g, '')
      .slice(0, 3)
      .toUpperCase()
      .padEnd(3, 'X');
  return `ORG-${typeSeg}-${citySeg}`;
}
